<template>
  <div class="maintenance-cycle">
    <section>
      <nav
        class="flex font-12 color-gray-2"
        v-bind:class="{ active: currentType == 'yuanchang' }"
        :style="'top:' + (from=='tt-oil' ? '0' : '1.06rem')"
      >
        <div
          class="nav-item"
          v-bind:class="{ 'active-color': currentType == 'baoyang' }"
          @click="changeType('baoyang')"
        >
          保养计划周期
        </div>
        <div
          class="nav-item"
          v-bind:class="{ 'active-color': currentType == 'yuanchang' }"
          @click="changeType('yuanchang')"
        >
          原厂配件参数
        </div>
      </nav>
      <section
        class="baoyang"
        v-show="currentType == 'baoyang' && maintenanceDatalist.length != 0"
      >
        <div class="title color-gray-2 font-13"  :style="'top:' + (from=='tt-oil' ? '0.65rem' : '1.68rem')">
          <div class="left flex">保养计划</div>
          <div class="right">
            <div class="fixbox">
              <div class="term-right-top font-11">
                <div
                  class="status"
                  v-for="(item, index) in maintenanceDatalist.header"
                  :key="index"
                >
                  <!--<p class='month color-gray2'>6个月</p>-->
                  <p class="color-gray5" v-text="item + 'KM'">5000KM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="term flex">
          <div class="term-left flex"  :style="'padding-top:' + (from=='tt-oil' ? '1.55rem' : '2.55rem')">
            <div class="term-left-item color-gray-2">
              <div
                class="status font-12"
                v-mar
                v-text="item.name"
                v-for="(item, index) in maintenanceDatalist.data"
                :key="index"
              ></div>
            </div>
          </div>
          <div class="term-right">
            <div
              class="term-right-item"
              v-for="(item, index) in maintenanceDatalist.data"
              :key="index"
            >
              <div
                class="status flex"
                v-for="(child, cindex) in maintenanceDatalist.header"
                :key="cindex"
              >
                <div
                  :class="{
                    cantRadio: item.state == 2,
                    radio: item.state == 1,
                  }"
                  v-show="child == item.value"
                  @click="item.state == 1 ? goOtherRecommend(item) : ''"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ycpj flex" v-if="currentType == 'yuanchang'">
        <div class="title color-gray5 font-12 flex" :style="'top:' + (from=='tt-oil' ? '0.75rem' : '1.8rem')">
          <div class="left flex">保养计划</div>
          <div class="left flex">规格型号</div>
          <div class="left flex">参考用量</div>
        </div>
        <div class="term" :style="'margin-top:' + (from=='tt-oil' ? '1.8rem' : '2.7rem')">
          <div class="item">
            <div class="term-left flex">
              <div class="status flex font-13 color-gray-2">
                <div>机油</div>
              </div>
              <div class="status flex font-13 color-gray-2">
                <div>
                  {{ info.engine_oil_grade ? info.engine_oil_grade : "-" }}
                </div>
              </div>
              <div class="status flex font-13 color-gray-2">
                <div
                  v-text="
                    info.engine_oil_capacity
                      ? info.engine_oil_capacity + 'L'
                      : '-'
                  "
                >
                  机油
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
    <LayoutEmpty
      v-if="loadData && rawDatalist.length == 0 && currentType == 'yuanchang'"
    ></LayoutEmpty>
  </div>
</template>

<script>
import api from "@/apis/maintenance-api";
import Vue from "vue";
import LayoutEmpty from "../../components/Layouts/LayoutEmpty";
import $ from "jquery";
import wx from "weixin-js-sdk";
Vue.directive("mar", {
  // eslint-disable-next-line no-unused-vars
  bind(el, binding) {
    var u = navigator.userAgent;
    // var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      setTimeout(function () {
        console.log();
        var index = $(el).parent().children().index($(el));
        // var s = 0;
        // var firstHeight = $(el).parent().children();
        //二次优化
        //直到最后一次才进行高度赋值
        if (index > 1) {
          $(el).css("marginTop", index / 12 + "px");
        }
      });
    }
  },
});
export default {
  name: "maintenance-cycle",
  components: {LayoutEmpty},
  data() {
    return {
      currentType: "baoyang",
      tipshow: true,
      maintenanceDatalist: {
        header: [5000, 10000, 15000, 20000, 30000, 40000, 55000, 60000],
        data: [
          {
            id: "5a702c67ad271a4cd47a0237",
            name: "小保养机油首保",
            value: 5000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a0238",
            name: "小保养机油二保",
            value: 5000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a0239",
            name: "小保养机油间隔",
            value: 10000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a023a",
            name: "小保养机油滤清首保",
            value: 5000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a023b",
            name: "小保养机油滤清间隔",
            value: 10000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a023c",
            name: "空气滤清器首保",
            value: 20000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a023d",
            name: "空气滤清器间隔",
            value: 20000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a023e",
            name: "燃油滤清器首保",
            value: 60000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a023f",
            name: "燃油滤清器间隔",
            value: 60000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a0240",
            name: "全部火花塞首保",
            value: 15000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a0241",
            name: "全部火花塞间隔",
            value: 20000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a0243",
            name: "整车制动液间隔",
            value: 40000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a0244",
            name: "自动变速箱油首保",
            value: 55000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a0245",
            name: "助力转向油间隔",
            value: 60000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a0246",
            name: "空调滤清器首保",
            value: 30000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a0247",
            name: "空调滤清器间隔",
            value: 30000,
            state: 2,
          },
          {
            id: "5a702c67ad271a4cd47a0242",
            name: "整车制动液首保",
            value: 40000,
            state: 2,
          },
        ],
      },
      rawDatalist: "",
      loadData: false,
      isfirst: true,
      info: {},
      from: "", // 来源
    };
  },
  created() {
    // var self = this;
    // self.currentType = 1;
    // if (self.$router.currentRoute.query.levelId) {
    //   self.levelId = self.$router.currentRoute.query.levelId;
    //   self.changeType("baoyang");
    // }
    // this.getData();
    // if (!localStorage.getItem("isfirst")) {
    //   localStorage.setItem("isfirst", true);
    // } else {
    //   this.isfirst = false;
    // }
  },
  methods: {
    // 获取车辆详情信息
    getDetail() {
      let loading = this.$loading;
      loading.show("加载中...");
      api
        .getVehicleDetailApi({
          vehicle_id: this.$route.query.levelId,
        })
        .then((data) => {
          loading.hide();
          if (data.code == 0) {
            this.info = data.data;
          } else {
            this.$toast.show({
              showTime: 2,
              message: data.message,
              style: "error",
            });
          }
        });
    },

    changeType(type) {
      this.currentType = type;
    },

    //其他保养项目推荐
    goOtherRecommend(item) {
      this.$router.push({
        path: "/maintenance-other-recommend",
        query: { id: item.id },
      });
    },

    scroll() {
      setTimeout(function () {
        console.log($(".term-right").eq(0).innerWidth() + "1111");
        $(".baoyang .right").width($(".term-right").eq(0).innerWidth());
        $(".fixbox")
          .eq(0)
          .scroll(function () {
            $(".term-right").scrollLeft($(this).scrollLeft()); // 横向滚动条
            console.log($(this).scrollLeft());
          });
        $(".term-right").scroll(function () {
          $(".fixbox").eq(0).scrollLeft($(this).scrollLeft());
        });
      });
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    this.from = window.sessionStorage.getItem("FROM");
    this.scroll();
    this.getDetail();
    if (this.browser.wx == 1) {
      wx.ready(function () {
        wx.hideAllNonBaseMenuItem();
      });
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../style/page/maintenance/cycle.less";
</style>
